// Real PDF of a submitted employment application, filed to Drive right
// after submit — same reasoning as signedDocumentPdf.js (offer letter/JD):
// the record shouldn't exist only as scattered DB columns. No email copy to
// the applicant needed for this one (per user instruction) — it's an
// internal record, not a document they need returned to them.
import React from 'react';
import { Document, Page, View, Text, pdf } from '@react-pdf/renderer';
import { styles, COLORS, Letterhead, ensureCursiveFont } from './pdfPrimitives';

const Field = ({ label, value }) => (
  <View style={{ flexDirection: 'row', marginBottom: 6 }}>
    <Text style={{ width: 160, fontSize: 8, color: COLORS.mid }}>{label}</Text>
    <Text style={{ flex: 1, fontSize: 9, color: '#000' }}>{value || '—'}</Text>
  </View>
);

function ApplicationPdf({ data }) {
  ensureCursiveFont();
  const { app, recordId } = data;
  return (
    <Document>
      <Page size="LETTER" style={styles.page}>
        <Letterhead />
        <View style={{ marginBottom: 10 }}>
          <Text style={{ fontFamily: 'Helvetica-Bold', fontSize: 14, color: COLORS.navy }}>Employment Application</Text>
        </View>

        <Text style={styles.sectionHdr}>Personal Information</Text>
        <Field label="Name" value={`${app.first_name} ${app.last_name}`} />
        <Field label="Email" value={app.email} />
        <Field label="Phone" value={app.phone} />
        <Field label="Address" value={[app.address, app.city, [app.state, app.zip].filter(Boolean).join(' ')].filter(Boolean).join(', ')} />
        <Field label="Date of Birth" value={app.date_of_birth} />

        <Text style={styles.sectionHdr}>Position</Text>
        <Field label="Position Applying For" value={app.position_applied_for} />
        <Field label="Employment Type Desired" value={app.employment_type_desired} />
        <Field label="Work History / Relevant Experience" value={app.work_history} />

        <View style={{ marginTop: 20 }}>
          <Text style={styles.sigLabel}>APPLICANT SIGNATURE</Text>
          <Text style={styles.signature}>{app.consent_signature_name}</Text>
          <View style={styles.sigLine} />
          <Text style={styles.sigName}>{app.consent_signature_name} — {new Date(app.consent_signed_at).toLocaleString()}</Text>
        </View>

        <View style={{ marginTop: 20 }}>
          <Text style={{ fontSize: 7, color: COLORS.mid }}>Signed electronically — ESIGN Act / UETA. Record ID: {recordId}</Text>
        </View>
      </Page>
    </Document>
  );
}

export async function renderApplicationPdfBlob(data) {
  return pdf(<ApplicationPdf data={data} />).toBlob();
}

export { blobToBase64 } from './trainingCertificatePdf';
